export default __webpack_public_path__ + "static/media/question_icon.d11b08af.svg";